

















































import { Component, Prop, Vue } from 'vue-property-decorator';
import AddressAutocomplete from '@/components/merchant-list/AddressAutocomplete.vue';
import { SearchMethod } from '@/enums/search-method';
import ToggleButton from '@/components/common/ToggleButton.vue';
import IconFilter from '@/components/icons/IconFilter.vue';
import IconMap from '@/components/icons/IconMap.vue';

@Component({
  components: {
    IconMap,
    IconFilter,
    ToggleButton,
    AddressAutocomplete,
  },
})
export default class AddressBar extends Vue {
  @Prop({ required: true }) private readonly searchMethod!: SearchMethod;

  @Prop({ required: true }) private readonly activeFiltersCount!: number;

  private get searchByLocation(): string {
    return SearchMethod.SearchByLocation;
  }

  private get searchByShopName(): string {
    return SearchMethod.SearchByShopName;
  }

  private onSearchMethodChange(searchMethod: SearchMethod): void {
    this.$emit('search-method-changed', searchMethod);
  }

  private onSearch(value: string): void {
    this.$emit('search', value);
  }
}
